export const PRINT_DEFAULT_VALUES = {
    name: "ABDUL LATHIF MOHAMMED AL REFEA EST.",
    address: {
        JUBAIL: "Branch – C.R.: 7011410037 Al Jubail 31951 P.O. Box 2594 King Abdullah Road Blue Palace Tower 1st Kingdom of Saudi Arabia",
        YANBU: "P.O. Box 1773, Yanbu Al-Balad District – King Abdulaziz Road, Yanbu 46424 – 6903, Kingdom of Saudi Arabia. C.R.: 4700017932",
    },
    arabicAddress: {
        JUBAIL: `فرع - سجل تجاري: ٧٠١١٤١٠٠٣٧
الجبيل ٣١٩٥١
صندوق بريد ٢٥٩٤
طريق الملك عبدالله
برج بلو بالاس ١
المملكة العربية السعودية`,
        YANBU: "ص.ب: 1773، حي ينبع البلد، طريق الملك عبدالعزيز، ينبع 46424-6903، المملكة العربية السعودية. س.ت: 4700017932",
    },
    mail: "info@arengineeringksa.com",
    crNumber: {
        JUBAIL: "7011410037",
        YANBU: "4700017932",
    },
    vatNumber: "301153562600003",
};

export type Branches = "YANBU" | "JUBAIL";
